<proffeo-ui-dialog [title]="'time-reports-form-modal-add-report' | translate">
  <div class="flex w-full flex-col gap-2">
    <proffeo-ui-button
      (clicked)="selectWorkTime()"
      variant="primary"
      text="time-reports-filters.kind-work-time"
    />
    <proffeo-ui-button
      (clicked)="selectAbsence()"
      variant="primary"
      text="time-reports-filters.kind-absence"
    />
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="cancel()"
      variant="primary"
      text="companies-cancel"
    />
  </div>
</proffeo-ui-dialog>
